/* External dependencies */
import { Col, Container, Div, Row, Text } from 'atomize';
import React from 'react';
import { Trans } from 'react-i18next';

/* Local dependencies */
import DownloadAppQRCode from '@components/website/downloadAppQRCode/DownloadAppQRCode';
import AppStoreIcon from '@svg/AppStoreIcon';
import GooglePlayIcon from '@svg/GooglePlayIcon';
import iPhone13 from '../../../../assets/images/iPhone13.png';
import MeducationDownloadButton, {
  MeducationDownloadAppButton,
} from '../ meducation-download-button';
import '../../styles/styles.scss';

interface MeducationHeroProps {
  imgStyle?: object;
  isDownloadQrCode: boolean;
  paddingY?: string | object;
  style?: object;
  title?: string;
}

export default function MeducationHero({
  imgStyle,
  isDownloadQrCode,
  paddingY = { xs: '1rem', md: '2rem' },
  style,
  title = 'learnQuick',
}: MeducationHeroProps) {
  const downloadButtons: MeducationDownloadAppButton[] = [
    {
      icon: (
        <GooglePlayIcon width={50} height={50} style={{ maxWidth: '100%' }} />
      ),
      id: 'googlePlayLink',
      link: 'https://play.google.com/store/apps/details?id=kg.medcheck.app&hl=ru',
      store: 'Google Play',
      text: 'downloadMeducationButtonAndroidText',
    },
    {
      icon: (
        <AppStoreIcon
          fill="#000"
          width={50}
          height={50}
          style={{ maxWidth: '100%' }}
        />
      ),
      id: 'appStoreLink',
      link: 'https://apps.apple.com/kg/app/medcheck/id1578873351',
      store: 'App Store',
      text: 'downloadMeducationButtonAppleText',
    },
  ];
  return (
    <main>
      <Container>
        <Row p={{ y: paddingY }}>
          <Col size={{ xs: '12', md: '6' }}>
            <Div m={{ b: { xs: '1rem', md: '2rem' } }}>
              <Text
                d="inline"
                tag="h1"
                title="Medcheck, Meducation"
                textSize={{
                  xs: 'title',
                  md: '65px',
                  xl: '91px',
                }}
                textColor="white"
                textWeight="900"
                style={{ lineHeight: '88.023%' }}
              >
                <Trans>{title}</Trans>
              </Text>
            </Div>
            <Div m={{ b: '1.25rem' }}>
              <Text
                textColor="white"
                textWeight="500"
                textSize={{
                  xs: 'body',
                  md: 'display1',
                  lg: 'display2',
                }}
              >
                <Trans>platformForPharmacistToLearn</Trans>
              </Text>
            </Div>
            <Div m={{ b: '2rem' }}>
              <Div d="flex" style={{ gap: '5px' }}>
                {downloadButtons.map((button) => (
                  <Div w="calc(50% - 5px)" maxW="250px" key={button.id}>
                    <MeducationDownloadButton
                      key={button.id}
                      icon={button.icon}
                      link={button.link}
                      store={button.store}
                      text={button.text}
                      id={button.id}
                      className={button.className}
                    />
                  </Div>
                ))}
              </Div>
            </Div>
            {isDownloadQrCode && (
              <Div
                w={{ xs: '180px', lg: '230px' }}
                d={{ xs: 'none', md: 'block' }}
              >
                <DownloadAppQRCode
                  rounded="40px"
                  padding="15px"
                  shadow={'0px 20px 100px 0px rgba(0, 0, 0, 0.10)'}
                />
              </Div>
            )}
          </Col>
          <Col size={{ xs: '12', md: '6' }} pos="relative" {...style}>
            <Div {...imgStyle}>
              <img
                src={iPhone13}
                alt="medcheck-phone"
                className="meducation-hero__img"
              />
            </Div>
          </Col>
        </Row>
      </Container>
    </main>
  );
}
